import request from '@/http/request'
import {
  getBanner,
  getSelectPlan,
  getDataList,
  getAuditInfo,
  getSignAndPayList,
  querySessionAvailable,
  queryTotalData,
  querySignCount,
  queryPhotoList,
  querySpotCount,
  queryCourseCount,
  queryExamIpAddress,
  getScreenPlanList,
  getPlanAllSession,
  batchList,
  getPlanReviewCourse,
  getScreenReviewTotal,
  getScreenReviewDateCount,
  getScreenReviewCourseList,
  getScreenReviewCountList,
  getScreenReviewDurationList,
  getScreenReviewScoreSection,
  getScreenReviewInfoList,
  querySessionNext,
  queryDatetimeCount,
  getDetecteTemplateById,
  getListDetecteTemplate,
  addDetecteTemplate,
  updateDetecteTemplate,
  deleteDetecteTemplate,
  intelligentDetecte4Ots,
  getTaskList,
  getTaskItem,
  createTask4IntelligentDetecte,
  deleteTask,
  stopTask,
  getOtsQuestionCount,
  generateTaskReport,
  getQuestionState,
  getQuestionType,
  getDetecteItemList,
  setDefaultDetecteTemplate,
  createTask4CheckSimilar,
  getTaskItemUnokCount,
  getTaskDetecteInfo,
  getTaskDetecteDescription,
  getTaskById,
  getPlanArchiveList,
  getPlanArchiveListFile,
  planArchiveArchiveOperate,
  planArchiveDownloadOperate,
  planArchiveDeleteOperate,
  getCategoryTree,
  getQuestionTypeByTaskIdAndCourseId,
  getQuestionForWaitQueue,
  getQuestionForWaitNumber,
  getQuestionForCountTotal,
  getQuestionForCountDetail,
  saveQuestionForOts,
  saveQuestionSingle,
  saveQuestionBatch,
  saveQuestionField,
  saveQuestionField4Sub
} from '@/http/api'

export const queryDatetimeCountApi = (data) => {
  return request({
    url: queryDatetimeCount,
    data
  })
}

export const querySessionNextApi = (data) => {
  return request({
    url: querySessionNext,
    data
  })
}

export const getScreenReviewInfoListApi = (data) => {
  return request({
    url: getScreenReviewInfoList,
    data
  })
}

export const getScreenReviewScoreSectionApi = (data) => {
  return request({
    url: getScreenReviewScoreSection,
    data
  })
}

export const getScreenReviewDurationListApi = (data) => {
  return request({
    url: getScreenReviewDurationList,
    data
  })
}

export const getScreenReviewCountListApi = (data) => {
  return request({
    url: getScreenReviewCountList,
    data
  })
}

export const getScreenReviewCourseListApi = (data) => {
  return request({
    url: getScreenReviewCourseList,
    data
  })
}

export const getScreenReviewDateCountApi = (data) => {
  return request({
    url: getScreenReviewDateCount,
    data
  })
}

export const getScreenReviewTotalApi = (data) => {
  return request({
    url: getScreenReviewTotal,
    data
  })
}

export const getPlanReviewCourseApi = (data) => {
  return request({
    url: getPlanReviewCourse,
    data
  })
}

export const getSelectPlanApi = (data) => {
  return request({
    url: getSelectPlan,
    data
  })
}

export const batchListApi = (data) => {
  return request({
    url: batchList,
    data
  })
}

export const getPlanAllSessionApi = (data) => {
  return request({
    url: getPlanAllSession,
    data
  })
}

export const queryExamIpAddressApi = (data) => {
  return request({
    url: queryExamIpAddress,
    data
  })
}

export const queryCourseCountApi = (data) => {
  return request({
    url: queryCourseCount,
    data
  })
}

export const querySpotCountApi = (data) => {
  return request({
    url: querySpotCount,
    data
  })
}

export const queryPhotoListApi = (data) => {
  return request({
    url: queryPhotoList,
    data
  })
}

export const querySignCountApi = (data) => {
  return request({
    url: querySignCount,
    data
  })
}

export const queryTotalDataApi = (data) => {
  return request({
    url: queryTotalData,
    data
  })
}

export const querySessionAvailableApi = (data) => {
  return request({
    url: querySessionAvailable,
    data
  })
}

export const getSignAndPayListApi = (data) => {
  return request({
    url: getSignAndPayList,
    data
  })
}

export const getAuditInfoApi = (data) => {
  return request({
    url: getAuditInfo,
    data
  })
}

export const getDataListApi = (data) => {
  return request({
    url: getDataList,
    data
  })
}

export const getBannerApi = (data) => {
  return request({
    url: getBanner,
    data
  })
}

export const getScreenPlanListApi = (data) => {
  return request({
      url: getScreenPlanList,
      data
  })
}

export const getDetecteTemplateByIdApi = (data) => {
  return request({
    url: getDetecteTemplateById,
    data
  })
}

export const getListDetecteTemplateApi = (data) => {
  return request({
    url: getListDetecteTemplate,
    data
  })
}

export const addDetecteTemplateApi = (data) => {
  return request({
    url: addDetecteTemplate,
    data
  })
}

export const updateDetecteTemplateApi = (data) => {
  return request({
    url: updateDetecteTemplate,
    data
  })
}

export const deleteDetecteTemplateApi = (data) => {
  return request({
    url: deleteDetecteTemplate,
    data
  })
}

export const intelligentDetecte4OtsApi = (data) => {
  return request({
    url: intelligentDetecte4Ots,
    data
  })
}

export const getTaskListApi = (data) => {
  return request({
    url: getTaskList,
    data
  })
}

export const getTaskItemApi = (data) => {
  return request({
    url: getTaskItem,
    data
  })
}

export const createTask4IntelligentDetecteApi = (data) => {
  return request({
    url: createTask4IntelligentDetecte,
    data
  })
}

export const deleteTaskApi = (data) => {
  return request({
    url: deleteTask,
    data
  })
}

export const stopTaskApi = (data) => {
  return request({
    url: stopTask,
    data
  })
}

export const getOtsQuestionCountApi = (data) => {
  return request({
    url: getOtsQuestionCount,
    data
  })
}

export const generateTaskReportApi = (data) => {
  return request({
    url: generateTaskReport,
    data
  })
}

export const getQuestionStateApi = (data) => {
  return request({
    url: getQuestionState,
    data
  })
}

export const getQuestionTypeApi = (data) => {
  return request({
    url: getQuestionType,
    data
  })
}

export const getDetecteItemListApi = (data) => {
  return request({
    url: getDetecteItemList,
    data
  })
}

export const setDefaultDetecteTemplateApi = (data) => {
  return request({
    url: setDefaultDetecteTemplate,
    data
  })
}

export const createTask4CheckSimilarApi = (data) => {
  return request({
    url: createTask4CheckSimilar,
    data
  })
}

export const getTaskItemUnokCountApi = (data) => {
  return request({
    url: getTaskItemUnokCount,
    data
  })
}

export const getTaskDetecteInfoApi = (data) => {
  return request({
    url: getTaskDetecteInfo,
    data
  })
}

export const getTaskDetecteDescriptionApi = (data) => {
  return request({
    url: getTaskDetecteDescription,
    data
  })
}

export const getTaskByIdApi = (data) => {
  return request({
    url: getTaskById,
    data
  })
}

export const getPlanArchiveListApi = (data) => {
  return request({
    url: getPlanArchiveList,
    data
  })
}

export const getPlanArchiveListFileApi = (data) => {
  return request({
    url: getPlanArchiveListFile,
    data
  })
}

export const planArchiveArchiveOperateApi = (data) => {
  return request({
    url: planArchiveArchiveOperate,
    data
  })
}

export const planArchiveDownloadOperateApi = (data) => {
  return request({
    url: planArchiveDownloadOperate,
    data
  })
}

export const planArchiveDeleteOperateApi = (data) => {
  return request({
    url: planArchiveDeleteOperate,
    data
  })
}

export const getCategoryTreeFn = (data) => {
  return request({
    url: getCategoryTree,
    data
  })
}
export const getQuestionTypeByTaskIdAndCourseIdFn = (data) => {
  return request({
    url: getQuestionTypeByTaskIdAndCourseId,
    data
  })
}
export const getQuestionForWaitQueueFn = (data) => {
  return request({
    url: getQuestionForWaitQueue,
    data
  })
}
export const getQuestionForWaitNumberFn = (data) => {
  return request({
    url: getQuestionForWaitNumber,
    data
  })
}
export const getQuestionForCountTotalFn = (data) => {
  return request({
    url: getQuestionForCountTotal,
    data
  })
}
export const getQuestionForCountDetailFn = (data) => {
  return request({
    url: getQuestionForCountDetail,
    data
  })
}
export const saveQuestionForOtsFn = (data) => {
  return request({
    url: saveQuestionForOts,
    data
  })
}
export const saveQuestionSingleFn = (data) => {
  return request({
    url: saveQuestionSingle,
    data
  })
}
export const saveQuestionBatchFn = (data) => {
  return request({
    url: saveQuestionBatch,
    data
  })
}
export const saveQuestionFieldFn = (data) => {
  return request({
    url: saveQuestionField,
    data
  })
}
export const saveQuestionField4SubFn = (data) => {
  return request({
    url: saveQuestionField4Sub,
    data
  })
}